import React from "react";
import Hero from "../components/Hero";
import TrustIntro from "../components/TrustIntro";
import Stats from "../components/Stats";
import Services from "../components/Services";
import WhyProspera from "../components/WhyProspera";
import HowWeWork from "../components/HowWeWork";
import Industries from "../components/Industries";
import DualCTA from "../components/DualCTA";
import GCCFeature from "../components/GCCFeature";
import Testimonials from "../components/Testimonials";
import CTABanner from "../components/CTABanner";

export default function Home() {
  return (
    <>
      <Hero />
      <div id="below-hero" />
      <TrustIntro />
      <Stats />
      <Services />
      <WhyProspera />
      <HowWeWork />
      <Industries />
      <DualCTA />
      <GCCFeature />
      <Testimonials />
      <CTABanner />
    </>
  );
}
